import React from "react";
import { Modal, Button } from "react-bootstrap";

export const Dialog = ({
  header,
  message,
  closeButtonText,
  saveButtonText,
  handleClose,
  handleSave,
  centered = true,
}) => {
  return (
    <Modal show onHide={handleClose} animation={false} centered={centered}>
      {header && (
        <Modal.Header closeButton>
          <Modal.Title>{header}</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer className='py-1'>
        <Button variant="secondary" className='py-1' onClick={handleClose}>
          {closeButtonText}
        </Button>
        <Button variant="primary" className='py-1' onClick={handleSave}>
          {saveButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default Dialog;
